(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
  function activateAutoplay(el) {
    el.setAttribute('autoplay', '10');
    ['play', 'autoPlayToggle', 'startAutoplay', 'handleAutoPlay'].forEach(function (m) {
      if (typeof el[m] === 'function') el[m]();
    });
  }
  customElements.whenDefined('slideshow-component').then(function () {
    document.querySelectorAll('slideshow-component').forEach(activateAutoplay);
  });

  // Força altura correta (16:5) nos banners da home em desktop
  // CSS aspect-ratio não funciona por causa do flexbox stretch do tema
  function fixBannerHeight() {
    if (window.innerWidth < 750) return;
    document.querySelectorAll('.slideshow-section slideshow-slide').forEach(function (slide) {
      slide.style.height = Math.round(slide.offsetWidth * 5 / 16) + 'px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBannerHeight);
  } else {
    fixBannerHeight();
  }
  window.addEventListener('resize', fixBannerHeight);
})();
  } catch(e) { console.error(e); }
})();

})();
